import { connect } from "react-redux";

var DropDownOptions = require("components/utility/DropDownOptions");
var LoadingButton = require("components/utility/LoadingButton");
var CurrentUser = require("lib/account/CurrentUser");

var RosterSelectors = require("lib/selectors/RosterSelectors");
var RosterActions = require("lib/actions/RosterActions");

@connect(
	(state, props) => ({
		defaultGradeLevel: parseInt(CurrentUser.get().grade_level) || 1,
		studentLists: RosterSelectors.studentLists({ state }),
	}),
	(dispatch, props) => ({
		createRoster: (studentsData) => {
			var data = {
				studentsData,
				noBackground: true
			};
			// // I think this might enable uploading as a wizard
			// if (props.effectiveUserID) {
			// 	data["effective_user_id"] = this.props.effectiveUserID;
			// }

			return dispatch(RosterActions.postRosters(data))
		}
	})
)

class ManualAddStudents extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		LuckyOrangeClient.tagComponent("ManualAddStudents");

		this.state = {
			...this.getInitialState(),

			// If set, shows only one class. Don't override when resetting
			shownStudentListID: props.defaultStudentListID,
		};
	}
	getInitialState() {
		return {
			byStudentListID: {
				// Keys: name, gradeLevel, firstNamesOnly
			},

			errors: {
				// Keys: Student list IDs + 'button'
			},

			// For batch upload
			loading: false,
			uploadProgressCount: null,
			uploadTotalCount: null,
		}
	}

	isVisibleStudentListID(studentListID) {
		return this.state.shownStudentListID && (
			this.state.shownStudentListID !== studentListID
		);
	}

	submitStudents() {
		var errors = {};

		var firstNames = [];
		var lastNames = [];
		var studentLists = [];
		var schoolOrgIDs = [];
		var gradeLevels = [];

		_.each(this.props.studentLists, (studentList) => {
			if (this.isVisibleStudentListID(studentList.id)) {
				return;
			}
			var slData = this.state.byStudentListID[studentList.id] || {};

			var studentNames = slData.names || "";
			var gradeLevel = slData.gradeLevel || this.props.defaultGradeLevel;
			var firstNamesOnly = !!slData.firstNamesOnly;

			if (firstNamesOnly) {
				var singleFirstNames = formatStudentNames(studentNames, /[\n\t\,]/);

				firstNames = firstNames.concat(singleFirstNames)
				lastNames = lastNames.concat(singleFirstNames.map(() => { return $wr.Constants.FILLER_LAST_NAME }));
				studentLists = studentLists.concat(singleFirstNames.map(() => { return studentList.name }));
				schoolOrgIDs = schoolOrgIDs.concat(singleFirstNames.map(() => { return studentList.school_org_id }));
				gradeLevels = gradeLevels.concat(singleFirstNames.map(() => { return gradeLevel }));

			} else {
				var studentLines = formatStudentNames(studentNames, /[\n]/);

				var namePairs = []
				studentLines.forEach((studentLine) => {
					var splitLines = formatStudentLines(studentLine, studentLines.length)

					splitLines.forEach((student) => {
						if (student.trim().length == 0) { return }
						var namePair = student.trim().split(/[\t ]/);
						var lastName = namePair.pop();
						var firstName = namePair.join(" ").replace(/^\d+\.\s+/, '');
						if (namePair.length >= 1) {
							lastNames.push(lastName);
							firstNames.push(firstName);
						}

						namePairs.push(namePair)
						studentLists.push(studentList.name);
						schoolOrgIDs.push(studentList.school_org_id);
						gradeLevels.push(gradeLevel);
					})
				});
				if (isNameMissing(namePairs)) {
					errors[studentList.id] = "Please enter a first and last name for each student.";
				}
			}
		});

		if (!firstNames.length && _.isEmpty(errors)) {
			errors["button"] = "Please enter at least one student's name.";

		} else if (_.isEmpty(errors)) {
			var studentsData = {
				first_name: firstNames, last_name: lastNames,
				classroom: studentLists, grade_level: gradeLevels
			};

			if (_.compact(schoolOrgIDs).length) {
				studentsData.school_org_id = schoolOrgIDs;
			}

			this.setState({
				loading: true,
				uploadProgressCount: 0,
				uploadTotalCount: studentsData.first_name.length
			}, () => {
				this.batchUploadStudents(studentsData, 0);
				this.props.onRosterUploadShowStatus(studentsData.first_name.length);
			});
		}

		this.setState({ errors });
	}


	batchUploadStudents(studentsData, previousCount) {
		const BATCH_SIZE = 5;
		const COLUMNS = [
			"first_name", "last_name", "classroom", "grade_level", "school_org_id"
		];

		var theseStudents = {};
		var remainingStudents = {};

		_.each(COLUMNS, (col) => {
			if (studentsData[col]) {
				theseStudents[col] = _.first(studentsData[col], BATCH_SIZE)
				remainingStudents[col] = _.rest(studentsData[col], BATCH_SIZE)
			}
		});

		this.props.createRoster(theseStudents).then((response) => {
			if (!response) { return }
			var totalCount = previousCount + response.student_count;

			if (remainingStudents.first_name.length > 0) {
				this.setState({ uploadProgressCount: totalCount });
				this.batchUploadStudents(remainingStudents, totalCount)

			} else {
				this.setState(this.getInitialState(), () => {
					if (this.props.afterCreate) {
						// Take: Number of students, and if the students are
						//   already in created and should be fetched immediately
						this.props.afterCreate(totalCount, true, null, response.classrooms);
					}
				});

			}
		})
	}

	setValue(studentListID, key, value) {
		this.setState({
			byStudentListID: {
				...this.state.byStudentListID,
				[studentListID]: {
					...this.state.byStudentListID[studentListID],
					[key]: value
				}
			}
		})
	}

	expandAllClasses(e) {
		$wr.nope(e);
		this.setState({ shownStudentListID: null });
	}

	render() {
		var sections = [];
		this.props.studentLists.forEach(studentList => {
			if (this.state.shownStudentListID) {
				if (this.isVisibleStudentListID(studentList.id)) {
					return;

				} else if (this.props.studentLists.length > 1) {
					var allClassesLink = (
						<a href="#" className="smallText" onClick={this.expandAllClasses}>
							View all
						</a>
					);
				}
			}

			var slData = this.state.byStudentListID[studentList.id] || {};

			var placeholder = slData.firstNamesOnly ?
				"Adam, Beth" :
				"Adam Apple, Beth Banks";

			var rowCount = Math.min(Math.max(
				(slData.names || "").split("\n").length, 2
			), 8);

			if (this.state.errors[studentList.id]) {
				var slErrorMessage = (
					<div className="errorRed smallText">
						{this.state.errors[studentList.id]}
					</div>
				);
			}

			sections.push(
				<div className="manualClass" key={studentList.id}>
					<div>
						<strong>{studentList.name}</strong> {allClassesLink}
					</div>
					{slErrorMessage}
					<div className="textAreaForm">
						<span className="inputFieldTitle">Names</span>
						<textarea value={slData.names || ""}
							onChange={(e) => this.setValue(studentList.id, "names", e.target.value)}
							className="form-control studentsTextArea"
							rows={rowCount}
							cols="20"
							placeholder={placeholder}
							autoComplete="off"
							autoCorrect="off"
							autoCapitalize="off"
							spellCheck="false" />
					</div>
					<div className="rightOps">
						<div className="gradeLevelContainer">
							<span className="inputFieldTitle">Grade</span>
							<select value={slData.gradeLevel || this.props.defaultGradeLevel}
								onChange={(e) => this.setValue(studentList.id, "gradeLevel", e.target.value)}
								className="form-control">
								{DropDownOptions.Select.GradeLevels()}
							</select>
						</div>

						<label className="normal firstNamesOnly">
							<input checked={!!slData.firstNamesOnly}
								onChange={(e) => this.setValue(studentList.id, "firstNamesOnly", !slData.firstNamesOnly)}
								type="checkbox" />

							{" "}Use student first names only
						</label>
					</div>
				</div>
			)
		})

		if (this.state.errors['button']) {
			var buttonErrorMessage = (
				<p className="errorRed smallText">
					{this.state.errors['button']}
				</p>
			);
		}

		if (this.state.uploadProgressCount != undefined) {
			var uploadProgress = (
				<p className="lightGray smallText">
					{this.state.uploadProgressCount} of {this.state.uploadTotalCount} uploaded...
				</p>
			);
		}

		return (
			<div className="manualAddStudents addStudentMethod">
				<p>
					Type or paste students' names here. For multiple students, use
					separate lines or a comma. For multiple grades or classes,
					repeat this process.
				</p>
				{sections}

				<div className="text-center">
					{buttonErrorMessage}
					{uploadProgress}
					<LoadingButton className="buttonSuccess"
						text="Add Students"
						onClick={this.submitStudents}
						loading={this.state.loading} />
				</div>
			</div>
		);
	}
};

// Helper methods for generating roster upload

function isNameMissing(namePairs) {
	return _.map(namePairs, (pair) => pair.length >= 1).includes(false)
}

function formatStudentLines(studentLine, studentLinesLength) {
	var splitLines = studentLine.split(",")
	if ((splitLines.length == 2) && (studentLinesLength > 1)) {
		splitLines.reverse();
		splitLines = [splitLines.join(" ")]
	}
	return splitLines
}

function formatStudentNames(studentNames, splitRegex) {
	var names = studentNames.split(splitRegex);
	return _.reject(names, (s) => {
		return s.trim().length == 0;
	});
}


ManualAddStudents.WrappedComponent.propTypes = StrictPropTypes({
	// From above
	defaultStudentListID: PropTypes.number,
	afterCreate: PropTypes.func,

	// Data from @connect
	defaultGradeLevel: PropTypes.number,
	studentLists: PropTypes.array,

	// Handlers from @connect
	createRoster: PropTypes.func,
	onRosterUploadShowStatus: PropTypes.func,
});

module.exports = ManualAddStudents;


// WEBPACK FOOTER //
// ./modules/components/org/roster_upload/ManualAddStudents.js